module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.0.0.box.528.494.658.84.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.12.0.0.box.528.494.658.84.q.90"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.185.926.1349.1235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.0.box.190.926.1340.155.q.60"
    }
  }, [_vm._v("I want to thank Pelican Publishing Company for its commitment to helping me to tell the stories of the young soldiers who lived and tragically died in Indiana's Camp Morton Civil War prison.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.188.1091.1346.98.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  }), _vm._v("I want to thank the Indiana Historical Society and its fine staff for assisting me with this project in many ways.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.2.box.189.1200.1341.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  }), _vm._v("Thanks to the library staff at the University of North Carolina at Chapel Hill for helping me with some photos used in this book.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.3.box.188.1309.1342.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("I am also grateful to the staff at the Shelbyville-Shelby County Public Library in Shelbyville, Indiana, for helping me to obtain information through interlibrary loans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.4.box.239.1472.1287.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.4.0"
    }
  }), _vm._v("I want to thank my friend Jeff Lahr for his computer-related counsel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.5.box.186.1526.1344.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.5.0"
    }
  }), _vm._v("Because I can't drive due to vision disability, I want to thank my wife, Mary, for serving as my taxi driver for all of the auto excursions that were necessary in the preparation of this book.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.6.box.188.1688.1341.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.6.0"
    }
  }), _vm._v("I also want to thank two of my former newspaper editors, Al Horton and Jim McKinney. When I was a young reporter, Al taught me how to dig to get to the heart of a good story and Jim taught me how to tell a good story.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.7.box.187.1906.1342.148.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.7.0"
    }
  }), _vm._v("I want to thank my late dad, Russell Hall, for sparking my interest in Civil War history when he took me to Gettysburg the summer before I entered third grade.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.8.box.185.2063.1342.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.8.0"
    }
  }), _vm._v("Last, but certainly not least, I want to t"), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("hank the Lord God, from whom all good gifts and all blessings flow.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b1b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 57
// module chunks = 0